import { TimesheetAdditionalBonusType } from "@/app/constants/timesheet/TimesheetAdditionalBonusType"

export const getTimesheetAdditionalBonusName = (type: TimesheetAdditionalBonusType, translate: (str: string) => string) : string => {
     const text: string = TimesheetAdditionalBonusType[type]
      return translate(`timesheetAdditionalBonus.${text}`)
}
